
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'embedded-viral-link-ui',
  currentProjectVersion: 'static-1.5326',
  depVersions: {
  "embedded-viral-link-ui": "static-1.5326",
  "head-dlb": "static-1.4210",
  "hs-test-utils": "static-1.7088",
  "hubspot-dlb": "static-2.1406",
  "HubStyleTokens": "static-2.10606",
  "I18n": "static-7.1410",
  "jasmine-runner": "static-1.5510",
  "quartz": "static-1.5851",
  "quartz-core": "static-1.5070",
  "react-dlb": "static-1.56",
  "webpack-env": "static-1.54",
  "cssUtils": "static-1.545",
  "enviro": "static-4.313",
  "foundations-components": "static-1.6452",
  "history": "static-4.47",
  "hub-http": "static-1.4807",
  "hubspot-url-utils": "static-1.3063",
  "HubStyle": "static-2.10914",
  "icons": "static-2.592",
  "immer": "static-1.33",
  "laboratory-lib": "static-3.6315",
  "PortalIdParser": "static-2.291",
  "quick-fetch": "static-1.2772",
  "react": "static-7.151",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.16",
  "react-rhumb": "static-1.15651",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.4551",
  "react-virtualized": "static-2.77",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "signup-constants": "static-1.16930",
  "signup-ui-lego-core": "static-1.18940",
  "styled-components": "static-2.64",
  "StyleGuideUI": "static-3.470",
  "ui-addon-react-router-dom": "static-1.8692",
  "ui-images": "static-2.904",
  "UIComponents": "static-3.7553",
  "usage-tracker": "static-1.6554",
  "usage-tracker-core": "static-1.6404",
  "viral-links-lib": "static-1.5970",
  "hs-promise-rejection-tracking": "static-1.4568",
  "raven": "static-3.5037",
  "raven-hubspot": "static-1.5344",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.8459",
  "bend-plugin-trellis-migration": "static-1.2689",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2128",
  "quartz-webpack": "static-1.2075",
  "HeadJS": "static-2.592",
  "framer-motion": "static-1.44",
  "hs-test-utils-bend-plugin": "static-1.2199",
  "msw": "static-1.39",
  "testing-library": "static-1.126",
  "foundations-theming": "static-1.3394",
  "i18n-data": "static-1.202",
  "moment-timezone": "static-5.51",
  "jasmine": "static-4.3438",
  "quartz-core-utils": "static-1.2718",
  "copilot-toolkit": "static-1.7932",
  "dispatcher": "static-1.117",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.665",
  "hub-http-shared-msw-handlers": "static-1.7454",
  "hubspotter-http": "static-1.3813",
  "hubspotter-http-shared-msw-handlers": "static-1.7452",
  "mobile-manifest-mixins": "static-1.363",
  "platform-navigation-bootstrap": "static-1.11514",
  "ui-fonts": "static-1.332",
  "sassPrefix": "static-1.136",
  "bend-plugin-foundations-components": "static-1.2721",
  "floating-ui": "static-1.32",
  "foundations-assets": "static-1.3990",
  "foundations-theming-specialty": "static-1.1111",
  "hs-story-utils": "static-1.8453",
  "react-aria": "static-1.42",
  "tanstack-table": "static-1.23",
  "superstore": "static-1.3858",
  "csstype": "static-1.38",
  "rpc-client-utils": "static-1.3826",
  "emoji-regex": "static-1.7",
  "PatternValidationJS": "static-1.437",
  "signup-ui-url-generator": "static-2.7151",
  "bend-plugin-foundations-theming": "static-1.1877",
  "foundations-theming-base": "static-1.2379",
  "chatspot-client-types": "static-1.9229",
  "chatspot-core": "static-1.17337",
  "ts-schema": "static-1.3339",
  "platform-infra-nav-components": "static-1.6924",
  "hs-lodash": "static-4.45"
},
  depPathPrefixes: {
  "embedded-viral-link-ui": "/embedded-viral-link-ui/static-1.5326",
  "head-dlb": "/head-dlb/static-1.4210",
  "hs-test-utils": "/hs-test-utils/static-1.7088",
  "hubspot-dlb": "/hubspot-dlb/static-2.1406",
  "HubStyleTokens": "/HubStyleTokens/static-2.10606",
  "I18n": "/I18n/static-7.1410",
  "jasmine-runner": "/jasmine-runner/static-1.5510",
  "quartz": "/quartz/static-1.5851",
  "quartz-core": "/quartz-core/static-1.5070",
  "react-dlb": "/react-dlb/static-1.56",
  "webpack-env": "/webpack-env/static-1.54",
  "cssUtils": "/cssUtils/static-1.545",
  "enviro": "/enviro/static-4.313",
  "foundations-components": "/foundations-components/static-1.6452",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.4807",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3063",
  "HubStyle": "/HubStyle/static-2.10914",
  "icons": "/icons/static-2.592",
  "immer": "/immer/static-1.33",
  "laboratory-lib": "/laboratory-lib/static-3.6315",
  "PortalIdParser": "/PortalIdParser/static-2.291",
  "quick-fetch": "/quick-fetch/static-1.2772",
  "react": "/react/static-7.151",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.16",
  "react-rhumb": "/react-rhumb/static-1.15651",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.4551",
  "react-virtualized": "/react-virtualized/static-2.77",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "signup-constants": "/signup-constants/static-1.16930",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.18940",
  "styled-components": "/styled-components/static-2.64",
  "StyleGuideUI": "/StyleGuideUI/static-3.470",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.8692",
  "ui-images": "/ui-images/static-2.904",
  "UIComponents": "/UIComponents/static-3.7553",
  "usage-tracker": "/usage-tracker/static-1.6554",
  "usage-tracker-core": "/usage-tracker-core/static-1.6404",
  "viral-links-lib": "/viral-links-lib/static-1.5970",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4568",
  "raven": "/raven/static-3.5037",
  "raven-hubspot": "/raven-hubspot/static-1.5344",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.8459",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2689",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2128",
  "quartz-webpack": "/quartz-webpack/static-1.2075",
  "HeadJS": "/HeadJS/static-2.592",
  "framer-motion": "/framer-motion/static-1.44",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2199",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.126",
  "foundations-theming": "/foundations-theming/static-1.3394",
  "i18n-data": "/i18n-data/static-1.202",
  "moment-timezone": "/moment-timezone/static-5.51",
  "jasmine": "/jasmine/static-4.3438",
  "quartz-core-utils": "/quartz-core-utils/static-1.2718",
  "copilot-toolkit": "/copilot-toolkit/static-1.7932",
  "dispatcher": "/dispatcher/static-1.117",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.665",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.7454",
  "hubspotter-http": "/hubspotter-http/static-1.3813",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.7452",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.363",
  "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11514",
  "ui-fonts": "/ui-fonts/static-1.332",
  "sassPrefix": "/sassPrefix/static-1.136",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2721",
  "floating-ui": "/floating-ui/static-1.32",
  "foundations-assets": "/foundations-assets/static-1.3990",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1111",
  "hs-story-utils": "/hs-story-utils/static-1.8453",
  "react-aria": "/react-aria/static-1.42",
  "tanstack-table": "/tanstack-table/static-1.23",
  "superstore": "/superstore/static-1.3858",
  "csstype": "/csstype/static-1.38",
  "rpc-client-utils": "/rpc-client-utils/static-1.3826",
  "emoji-regex": "/emoji-regex/static-1.7",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7151",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1877",
  "foundations-theming-base": "/foundations-theming-base/static-1.2379",
  "chatspot-client-types": "/chatspot-client-types/static-1.9229",
  "chatspot-core": "/chatspot-core/static-1.17337",
  "ts-schema": "/ts-schema/static-1.3339",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6924",
  "hs-lodash": "/hs-lodash/static-4.45"
}
};
